import cn from 'classnames';
import {CashBackStatus} from '../../../lendtech/cashBack/api/getCashBackCards/cashBackCards.types';
import {statusTypeLabels} from './getCashBackLabels';

export const greenBadgeStyles =
  'bg-[#FAFDF7] border-farm-shop-200 text-farm-shop-500';
export const redBadgeStyles = 'text-red-500 bg-[#FFFBFA]';
export const baseBadgeClassName =
  'justify-end px-2 py-1 mr-auto text-xs font-medium border-[1px] rounded-full w-fit ';

const getCurrentCashBackBadge = (status: CashBackStatus) => {
  if (status === CashBackStatus.Inactive) {
    return null;
  }

  let badgeText = '';
  let variantClassName = '';

  switch (status) {
    case CashBackStatus.Active:
    case CashBackStatus.RequestToWithdrawal:
      badgeText = statusTypeLabels[CashBackStatus.Active];
      variantClassName = greenBadgeStyles;
      break;

    case CashBackStatus.Expired:
      badgeText = statusTypeLabels[CashBackStatus.Expired];
      variantClassName = redBadgeStyles;
      break;

    default:
      break;
  }

  return (
    <div className={cn(baseBadgeClassName, variantClassName)}>{badgeText}</div>
  );
};

const getPaidCashBackBadge = (status: CashBackStatus) => {
  let badgeText = '';
  let variantClassName = '';

  switch (status) {
    case CashBackStatus.Paid:
      badgeText = 'وجه برداشت شده';
      variantClassName = greenBadgeStyles;
      break;

    case CashBackStatus.Consumed:
      badgeText = 'اعتبار استفاده شده';
      variantClassName = greenBadgeStyles;
      break;

    default:
      badgeText = 'وضعیت نامشخص';
      variantClassName = 'text-gray-500';
      break;
  }

  return (
    <div className={cn(baseBadgeClassName, variantClassName)}>{badgeText}</div>
  );
};

export {getCurrentCashBackBadge, getPaidCashBackBadge};
